import * as Yup from "yup";

const initValuesTraining = {
  type: "Recomendación",
  subType: "Persona física",
  capacitacionPublica: {
    institucion: '',
    direccion: '',
    correo: '',
    responsable: '',
    correo_responsable: '',
    telefono_responsable: '',
    publico: '',
    cantidad: '',
    tema: '',
    fechas: '',
    lugar: '',
  },
  RecomendacionPublica: {
    institucion: '',
    direccion: '',
    correo: '',
    responsable: '',
    correo_responsable: '',
    telefono_responsable: '',
    acto: '',
    motivo: '',
    documento: null,
  },
  RecomendacionFisica: {
    nombre: '', 
    cedula: '',
    direccion: '',
    correo: '',
    telefono: '',
    acto: '',
    motivo: '',
    documento: null,
  },
  RecomendacionAgente: {
    empresa: '',
    direccion: '',
    correo: '',
    responsable: '',
    correo_responsable: '',
    telefono_responsable: '',
    acto: '',
    motivo: '',
    documento: null,
  },
  capacitacionPersona: {
    nombre: '', 
    cedula: '',
    direccion: '',
    correo: '',
    telefono: '',
    publico: '',
    cantidad: '',
    tema: '',
    fechas: '',
    lugar: '',
  },
  capacitacionAgente: {
    empresa: '',
    direccion: '',
    telefono: '',
    correo: '',
    responsable: '',
    correo_responsable: '',
    telefono_responsable: '',
    publico: '',
    cantidad: '',
    tema: '',
    fechas: '',
    lugar: '',
  },
};

const publicTrainingSchema = Yup.object().shape({
  institucion: Yup.string().required('Por favor, ingrese el nombre de la institución.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  telefono: Yup.string().required('Por favor, ingrese el número de teléfono.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  responsable: Yup.string().required('Por favor, ingrese el nombre de la persona responsable.'),
  correo_responsable: Yup.string().email('Por favor, ingrese un correo electrónico válido para el responsable.').required('Por favor, ingrese el correo del responsable.'),
  telefono_responsable: Yup.string().required('Por favor, ingrese el número de teléfono del responsable.'),
  publico: Yup.string().required('Por favor, indique el público destinatario.'),
  cantidad: Yup.number().typeError('Por favor, ingrese un número válido.').required('Por favor, indique la cantidad de personas.'),
  tema: Yup.string().required('Por favor, indique el tema de interés.'),
  fechas: Yup.string().required('Por favor, indique las fechas y horarios.'),
  lugar: Yup.string().required('Por favor, indique el lugar de la capacitación.'),
});

const recomendacionPublicaSchema = Yup.object().shape({
  institucion: Yup.string().required('Por favor, ingrese el nombre de la institución.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  telefono: Yup.string().required('Por favor, ingrese el número de teléfono.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  responsable: Yup.string().required('Por favor, ingrese el nombre del responsable.'),
  correo_responsable: Yup.string().email('Por favor, ingrese un correo válido para el responsable.').required('Por favor, ingrese el correo electrónico del responsable.'),
  telefono_responsable: Yup.string().required('Por favor, ingrese el número de teléfono del responsable.'),
  acto: Yup.string().required('Por favor, ingrese el acto correspondiente.'),
  motivo: Yup.string().required('Por favor, ingrese el motivo.'),
  documento: Yup.mixed().nullable(),
});

const recomendacionFisicaSchema = Yup.object().shape({
  nombre: Yup.string().required('Por favor, ingrese el nombre completo.'),
  cedula: Yup.string().required('Por favor, ingrese la cédula.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  telefono: Yup.string().required('Por favor, ingrese el número de contacto.'),
  acto: Yup.string().required('Por favor, ingrese el nombre del acto administrativo.'),
  motivo: Yup.string().required('Por favor, detalle el motivo de la solicitud.'),
  documento: Yup.mixed().nullable(),
});

const recomendacionAgenteSchema = Yup.object().shape({
  empresa: Yup.string().required('Por favor, ingrese el nombre de la empresa.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  telefono: Yup.string().required('Por favor, ingrese el número de teléfono.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  responsable: Yup.string().required('Por favor, ingrese el nombre de la persona responsable.'),
  correo_responsable: Yup.string().email('Por favor, ingrese un correo válido para el responsable.').required('Por favor, ingrese el correo del responsable.'),
  telefono_responsable: Yup.string().required('Por favor, ingrese el número de contacto del responsable.'),
  acto: Yup.string().required('Por favor, ingrese el nombre del acto administrativo.'),
  motivo: Yup.string().required('Por favor, detalle el motivo de la solicitud.'),
  documento: Yup.mixed().nullable(),
});

const capacitacionPersonaSchema = Yup.object().shape({
  nombre: Yup.string().required('Por favor, ingrese el nombre completo.'),
  cedula: Yup.string().required('Por favor, ingrese la cédula.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  telefono: Yup.string().required('Por favor, ingrese el número de contacto.'),
  publico: Yup.string().required('Por favor, indique el público destinatario.'),
  cantidad: Yup.number().typeError('Por favor, ingrese un número válido.').required('Por favor, indique la cantidad de personas.'),
  tema: Yup.string().required('Por favor, indique el tema de interés.'),
  fechas: Yup.string().required('Por favor, indique las fechas y horarios.'),
  lugar: Yup.string().required('Por favor, indique el lugar de la capacitación.'),
});

const capacitacionAgenteSchema = Yup.object().shape({
  empresa: Yup.string().required('Por favor, ingrese el nombre de la empresa.'),
  direccion: Yup.string().required('Por favor, ingrese la dirección.'),
  telefono: Yup.string().required('Por favor, ingrese el número de teléfono.'),
  correo: Yup.string().email('Por favor, ingrese un correo válido.').required('Por favor, ingrese el correo electrónico.'),
  responsable: Yup.string().required('Por favor, ingrese el nombre de la persona responsable.'),
  correo_responsable: Yup.string().email('Por favor, ingrese un correo válido para el responsable.').required('Por favor, ingrese el correo del responsable.'),
  telefono_responsable: Yup.string().required('Por favor, ingrese el número de teléfono del responsable.'),
  publico: Yup.string().required('Por favor, indique el público destinatario.'),
  cantidad: Yup.number().typeError('Por favor, ingrese un número válido.').required('Por favor, indique la cantidad de personas.'),
  tema: Yup.string().required('Por favor, indique el tema de interés.'),
  fechas: Yup.string().required('Por favor, indique las fechas y horarios.'),
  lugar: Yup.string().required('Por favor, indique el lugar de la capacitación.'),
});


const validationSchemaTraining = Yup.object().shape({
  type: Yup.string().required('Por favor colocar el tipo de servicio.'),
  subType: Yup.string().required('Por favor colocar el subtipo del de servicio.'),


  capacitacionPublica: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Capacitación' && subType === 'Institución pública',
    then: (schema) => publicTrainingSchema, 
    otherwise: (schema) => schema.notRequired(),
  }),

 
  RecomendacionPublica: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Recomendación' && subType === 'Institución pública',
    then: (schema) => recomendacionPublicaSchema, 
    otherwise: (schema) => schema.notRequired(),
  }),

 
  RecomendacionFisica: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Recomendación' && subType === 'Persona física',
    then: (schema) => recomendacionFisicaSchema,
    otherwise: (schema) => schema.notRequired(),
  }),

  RecomendacionAgente: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Recomendación' && subType === 'Agente económico',
    then: (schema) => recomendacionAgenteSchema, 
    otherwise: (schema) => schema.notRequired(),
  }),

  capacitacionPersona: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Capacitación' && subType === 'Persona física',
    then: (schema) => capacitacionPersonaSchema, // Pass the schema object
    otherwise: (schema) => schema.notRequired(),
  }),

  capacitacionAgente: Yup.object().when(['type', 'subType'], {
    is: (type, subType) => type === 'Capacitación' && subType === 'Agente económico',
    then: (schema) => capacitacionAgenteSchema,
    otherwise: (schema) => schema.notRequired(),
  }),
});

export { initValuesTraining, validationSchemaTraining };